// extracted by mini-css-extract-plugin
export var labelWrapper = "_c2-0";